import { useUsers } from "@/lib/api/user";
import { useMemo } from "react";

export const useLeadMentorFilterOptions = (enabled: boolean) => {
  const query = useUsers({
    page: 1,
    perPage: 1000,
    assignedRole: "lead_mentor",
    enabled,
  });

  const options = useMemo(
    () =>
      query.data?.users.map((user) => ({
        value: user.id,
        label: user.name ?? user.email ?? user.id,
      })) ?? [],
    [query.data?.users],
  );

  return { ...query, options };
};
